import { getBikeFitment } from 'app/product/utils/getBikeFitment';
import { CheckIcon, TriangleAlertIcon } from 'lucide-react';
import type { ProductDocument, ProductLight } from 'models/product';
import type { UserDocument } from 'models/user';

type ProductFitmentProps = {
  product: ProductLight | ProductDocument;
  userDoc: UserDocument | null | undefined;
};

export default function ProductFitment({ ...props }: ProductFitmentProps) {
  const isBikePart = props.product.category.toLowerCase().includes('parts');

  if (!isBikePart) {
    return null;
  }

  const fittingBikesParsed = props.product.fitting_bikes_strings?.length
    ? props.product.fitting_bikes_strings.map((s) => {
        const [year, make, model] = s.split('|');
        const yearNum = year ? parseInt(year, 10) : null;
        return {
          year: yearNum !== null && !Number.isNaN(yearNum) ? yearNum : null,
          make: make || null,
          model: model || null,
        };
      })
    : [];

  const productHasValidFittingBikes =
    !!(props.product as ProductDocument)?.fitting_bikes?.bikes?.length &&
    (props.product as ProductDocument)?.fitting_bikes?.bikes?.every(
      (bike) => bike.make && bike.year && bike.model
    );

  const isUniversal =
    (props.product as ProductDocument)?.fitting_bikes?.universal ?? false;
  const fittingBikes = productHasValidFittingBikes
    ? (props.product as ProductDocument)?.fitting_bikes?.bikes ?? []
    : fittingBikesParsed;

  const fitment = getBikeFitment(
    fittingBikes,
    props.userDoc?.bikes ?? [],
    false
  );

  if (fitment.status !== 'fits') return null;

  if (isUniversal) {
    return (
      <div className="mb-4 flex items-center gap-2 font-medium text-yellow-600">
        <div className="h-6 w-6">
          <TriangleAlertIcon className="h-full w-full text-yellow-600" />
        </div>
        Universal fitment
      </div>
    );
  }

  return (
    <div className="mb-4 flex items-center gap-2 font-medium text-[#1E7A1E]">
      <div className="h-6 w-6 rounded-full bg-[#1E7A1E] p-1">
        <CheckIcon className="h-full w-full text-white" />
      </div>
      Fits your vehicle
    </div>
  );
}
